module.exports = __webpack_public_path__ + "static/media/parking-illustration.9d81c5e7.gif";